module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/payment-on-invoice-cs-6868dc83aa827c3c5ce3171db8d90f43.svg";